
import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import CompanySelectorModal from "../../components/widgets/Modals/CompanySelectorModal.vue";
import { getModule } from "vuex-module-decorators";
import { CompanyModule } from "@/store/modules/index";

const companyModule = getModule(CompanyModule);

@Component({
  components: {
    Select,
    CompanySelectorModal
  }
})
export default class BillToSelect extends Mixins(formMixin, formOptionsMixin, formValidationMixin) {
  companies: Array<any> = [];

  @Ref() readonly billToSelectorModal!: CompanySelectorModal;

  @Prop({ default: false })
  isNewOrder: boolean;

  @Prop({ default: false })
  typeAhead: boolean;

  async created() {
    if (this.localValue) await this.search(this.localValue, null);
  }

  lookup() {
    this.billToSelectorModal.show();
  }

  async companySelected(company) {
    if (company && company.id) {
      if (this.multiple) this.localValue.push(company.id);
      else {
        this.localValue = company.id;
        if (this.typeAhead) await this.search(this.localValue, null);
      }
    }
  }
  async search(value, loading) {
    if (loading) loading(true);

    if (!value || value == "") {
      this.companies = [];
      return;
    }

    companyModule
      .searchCompaniesTypeAhead({
        typeAheadValue: value,
        includeBillTos: true,
        excludeRestrictedNewOrderBillTos: this.isNewOrder,
        sort: "Name"
      })
      .then(response => {
        this.companies = response.data.map((x: any) => ({
          label: x.name + " (" + x.id + ")",
          value: x.id
        }));
      })
      .catch(error => {})
      .finally(() => {
        if (loading) loading(false);
      });
  }
}
